import { tokens } from './tokens';

export type ThemeMode = 'light' | 'dark';

export const lightTheme = {
  mode: 'light' as ThemeMode,
  colors: {
    primary: tokens.colors.primary[600],
    primaryHover: tokens.colors.primary[700],
    primaryLight: tokens.colors.primary[50],
    
    background: '#ffffff',
    backgroundSecondary: tokens.colors.neutral[50],
    backgroundTertiary: tokens.colors.neutral[100],
    
    surface: '#ffffff',
    surfaceHover: tokens.colors.neutral[50],
    
    text: tokens.colors.neutral[900],
    textSecondary: tokens.colors.neutral[600],
    textTertiary: tokens.colors.neutral[500],
    
    border: tokens.colors.neutral[200],
    borderHover: tokens.colors.neutral[300],
    
    success: tokens.colors.success[600],
    successLight: tokens.colors.success[50],
    error: tokens.colors.error[600],
    errorLight: tokens.colors.error[50],
    warning: tokens.colors.warning[600],
    warningLight: tokens.colors.warning[50],
  },
  spacing: tokens.spacing,
  borderRadius: tokens.borderRadius,
  fontSize: tokens.fontSize,
  fontWeight: tokens.fontWeight,
  lineHeight: tokens.lineHeight,
  shadows: tokens.shadows,
  breakpoints: tokens.breakpoints,
} as const;

export const darkTheme = {
  mode: 'dark' as ThemeMode,
  colors: {
    primary: tokens.colors.primary[500],
    primaryHover: tokens.colors.primary[400],
    primaryLight: tokens.colors.primary[900],
    
    background: tokens.colors.neutral[900],
    backgroundSecondary: tokens.colors.neutral[800],
    backgroundTertiary: tokens.colors.neutral[700],
    
    surface: tokens.colors.neutral[800],
    surfaceHover: tokens.colors.neutral[700],
    
    text: tokens.colors.neutral[50],
    textSecondary: tokens.colors.neutral[300],
    textTertiary: tokens.colors.neutral[400],
    
    border: tokens.colors.neutral[700],
    borderHover: tokens.colors.neutral[600],
    
    success: tokens.colors.success[500],
    successLight: tokens.colors.neutral[800],
    error: tokens.colors.error[500],
    errorLight: tokens.colors.neutral[800],
    warning: tokens.colors.warning[500],
    warningLight: tokens.colors.neutral[800],
  },
  spacing: tokens.spacing,
  borderRadius: tokens.borderRadius,
  fontSize: tokens.fontSize,
  fontWeight: tokens.fontWeight,
  lineHeight: tokens.lineHeight,
  shadows: tokens.shadows,
  breakpoints: tokens.breakpoints,
} as const;

export type Theme = typeof lightTheme | typeof darkTheme;
